import type { CaptureContext } from '@sentry/core';

import { BaseApiError } from '../Api/BaseApiError';

import { captureException, captureMessage } from './captureUtils';

export const loggerUtils = {
  logMessageToConsole(message: string, ...optionalParameters: any[]): void {
    // eslint-disable-next-line no-console
    console.log(message, ...optionalParameters);
  },
  logToConsole(error: Error, extra?: object): void {
    // eslint-disable-next-line no-console
    console.error(error, extra);
  },
  logException(error: Error, otherProps?: CaptureContext): void {
    // eslint-disable-next-line no-console
    console.error(error, otherProps);
    if (!(error instanceof BaseApiError)) {
      captureException(error, {
        ...otherProps,
      });
    }
  },
  logMessage(error: Error, otherProps?: CaptureContext): void {
    // eslint-disable-next-line no-console
    console.log(error, otherProps);
    captureMessage(error.message, {
      ...otherProps,
    });
  },
};
